
import Vue from 'vue';
import $clamp from './js/clamp';
//普通input聚焦指令
const focus =  Vue.directive('autoFcs',{
  // 钩子函数，被绑定元素插入父节点时调用 (父节点存在即可调用，不必存在于 document 中)。
  inserted(el,binding,vnode){
    // el : 指令所绑定的元素，可以用来直接操作DOM
    // binding: 一个对象，包含指令的很多信息
    // vnode: VUE编译生成的虚拟节点

    if(binding.arg==="first") {  //循环dom只在第一个聚焦
       if (binding.value == 0) return el.focus();
       return;
    }
     el.focus()
  },
  // 只调用一次，指令第一次绑定到元素时调用，用这个钩子函数可以定义一个在绑定时执行一次的初始化动作。
  bind(){
    // console.log( 'bind' );
  },
  // 所在组件的 VNode 更新时调用，但是可能发生在其孩子的 VNode 更新之前。
  // 指令的值可能发生了改变也可能没有。但是你可以通过比较更新前后的值来忽略不必要的模板更新
  update(){
    // console.log( 'update' );
  },
  // 所在组件的 VNode 及其孩子的 VNode 全部更新时调用。
  componentUpdated(){
    // console.log( 'componentUpdated' );
  },
  // 只调用一次，指令与元素解绑时调用。
  unbind(){
    // console.log( 'unbind' );
  }
});
// el-input type=textarea默认聚焦指令
const focusArea =  Vue.directive('autoArea',{
  // 钩子函数，被绑定元素插入父节点时调用 (父节点存在即可调用，不必存在于 document 中)。
  inserted(el){
    el.querySelector('textarea').focus()
    // console.log( 'inserted' );
  },
  // 只调用一次，指令第一次绑定到元素时调用，用这个钩子函数可以定义一个在绑定时执行一次的初始化动作。
  bind(){
    // console.log( 'bind' );
  },
  // 所在组件的 VNode 更新时调用，但是可能发生在其孩子的 VNode 更新之前。
  // 指令的值可能发生了改变也可能没有。但是你可以通过比较更新前后的值来忽略不必要的模板更新
  update(){
    // console.log( 'update' );
  },
  // 所在组件的 VNode 及其孩子的 VNode 全部更新时调用。
  componentUpdated(){
    // console.log( 'componentUpdated' );
  },
  // 只调用一次，指令与元素解绑时调用。
  unbind(){
    // console.log( 'unbind' );
  }
});
// el-input默认聚焦指令
const focusInput =  Vue.directive('autoInput',{
  // 钩子函数，被绑定元素插入父节点时调用 (父节点存在即可调用，不必存在于 document 中)。
  inserted(el){
    el.querySelector('input').focus()
    // console.log( 'inserted' );
  },
  // 只调用一次，指令第一次绑定到元素时调用，用这个钩子函数可以定义一个在绑定时执行一次的初始化动作。
  bind(){
    // console.log( 'bind' );
  },
  // 所在组件的 VNode 更新时调用，但是可能发生在其孩子的 VNode 更新之前。
  // 指令的值可能发生了改变也可能没有。但是你可以通过比较更新前后的值来忽略不必要的模板更新
  update(){
    // console.log( 'update' );
  },
  // 所在组件的 VNode 及其孩子的 VNode 全部更新时调用。
  componentUpdated(){
    // console.log( 'componentUpdated' );
  },
  // 只调用一次，指令与元素解绑时调用。
  unbind(){
    // console.log( 'unbind' );
  }
});
// 放大缩小指令
const zoom =  Vue.directive('zoom',{
  // 钩子函数，被绑定元素插入父节点时调用 (父节点存在即可调用，不必存在于 document 中)。
  inserted(el,binding){
    // console.log(el)
    // if(binding.arg){
    //   el = el.firstChild
    // }
    // console.log(el)
    // el.onmousewheel=function(){
    //   let zoom = parseInt(el.style.zoom,10)||100;
    //   zoom += event.wheelDelta / 12;
    //   if(zoom > 0 )
    //     el.style.zoom=zoom+'%';
    //   return false;
    // }
    console.log( 'inserted' );

  },
  // 只调用一次，指令第一次绑定到元素时调用，用这个钩子函数可以定义一个在绑定时执行一次的初始化动作。
  bind(el,binding){
    // if(binding.arg){
    //   el = el.firstChild
    // }
    el.onmousewheel=function(){
      let zoom = parseInt(el.style.zoom,10)||100;
      zoom += event.wheelDelta / 12;
      if(zoom > 0 )
        el.style.zoom=zoom+'%';
      return false;
    }
    // console.log( 'bind' );
  },
  // 所在组件的 VNode 更新时调用，但是可能发生在其孩子的 VNode 更新之前。
  // 指令的值可能发生了改变也可能没有。但是你可以通过比较更新前后的值来忽略不必要的模板更新
  update(){
    // console.log( 'update' );
  },
  // 所在组件的 VNode 及其孩子的 VNode 全部更新时调用。
  componentUpdated(){
    // console.log( 'componentUpdated' );
  },
  // 只调用一次，指令与元素解绑时调用。
  unbind(){
    // console.log( 'unbind' );
  }
});

// 弹窗 移动指令 v-diaMove
const diaMove =  Vue.directive('diaMove',{
  // 钩子函数，被绑定元素插入父节点时调用 (父节点存在即可调用，不必存在于 document 中)。
  inserted(el){
    let clientW = document.documentElement.clientWidth
    let clientH = document.documentElement.clientHeight
    let dvW = el.firstChild.offsetWidth
    let dvH = el.firstChild.offsetHeight
    let x = 0;
    let y = 0;
    let l = 0;
    let t = 0;
    let imgDom = el.firstChild;

    let moveDv = el.querySelector('.el-dialog__header')
    moveDv.style.cursor = 'move'
    // el.style.position = 'relative';
    moveDv.onmousedown = function(event) {

      x = event.clientX;  //鼠标
      y = event.clientY;
      //获取左部和顶部的偏移量
      l = imgDom.offsetLeft;
      t = imgDom.offsetTop;

      imgDom.style.position = 'absolute';
      imgDom.style.marginTop  = '0';
      imgDom.style.left = l + 'px';
      imgDom.style.top = t + 'px';

      console.log(x,y)
      console.log(l,t)

      el.onmousemove = function(event) {

        console.log(event)
        //获取x和y
        var nx = event.clientX;
        var ny = event.clientY;

        //计算移动后的左偏移量和顶部的偏移量
        var nl = nx - (x - l);
        var nt = ny - (y - t);
        if(nl<=0){ nl=0}
        if(nt<=0){nt=0}
        if((dvW+nl)>clientW){
          nl=clientW - dvW
        }
          if((dvH+nt)>clientH){
            nt=clientH - dvH
          }
        // dvW  dvH
        // clientW clientH
        imgDom.style.left = nl + 'px';
        imgDom.style.top = nt + 'px';
      }
      document.onmouseup = function() {
        console.log( 'onmouseup' );
        el.onmousemove = null;
      }
    }
  },
  // 只调用一次，指令第一次绑定到元素时调用，用这个钩子函数可以定义一个在绑定时执行一次的初始化动作。
  bind(){
    // console.log( 'bind' );
  },
  // 所在组件的 VNode 更新时调用，但是可能发生在其孩子的 VNode 更新之前。
  // 指令的值可能发生了改变也可能没有。但是你可以通过比较更新前后的值来忽略不必要的模板更新
  update(){
    // console.log( 'update' );
  },
  // 所在组件的 VNode 及其孩子的 VNode 全部更新时调用。
  componentUpdated(){
    // console.log( 'componentUpdated' );
  },
  // 只调用一次，指令与元素解绑时调用。
  unbind(){
    // console.log( 'unbind' );
  }
});

// 按压移动指令
const move =  Vue.directive('move',{
  // 钩子函数，被绑定元素插入父节点时调用 (父节点存在即可调用，不必存在于 document 中)。
  inserted(el){
    let imgDom = el.firstChild;
    el.style.position = 'relative';
    imgDom.style.position = 'absolute';
    imgDom.onmousedown = function(event) {
      console.log( 'onmousedown' );
      event = event || window.event;
      var positionX = event.clientX - imgDom.offsetLeft;
      var positionY = event.clientY - imgDom.offsetTop;

      el.onmousemove = function(event) {
        console.log( 'onmousemove' );
        event = event || window.event;
        var divX = event.clientX - positionX;
        var divY = event.clientY - positionY;
        imgDom.style.left = divX + 'px';
        imgDom.style.top = divY + 'px';
      }
      document.onmouseup = function() {
        console.log( 'onmouseup' );
        el.onmousemove = null;
      }
    }
  },
  // 只调用一次，指令第一次绑定到元素时调用，用这个钩子函数可以定义一个在绑定时执行一次的初始化动作。
  bind(){
    // console.log( 'bind' );
  },
  // 所在组件的 VNode 更新时调用，但是可能发生在其孩子的 VNode 更新之前。
  // 指令的值可能发生了改变也可能没有。但是你可以通过比较更新前后的值来忽略不必要的模板更新
  update(){
    // console.log( 'update' );
  },
  // 所在组件的 VNode 及其孩子的 VNode 全部更新时调用。
  componentUpdated(){
    // console.log( 'componentUpdated' );
  },
  // 只调用一次，指令与元素解绑时调用。
  unbind(){
    // console.log( 'unbind' );
  }
});
const input =  Vue.directive("input",{
  //仅针对element ui input框
   bind(el, binding) {
     //只能输入整数
     if(binding.arg==='int'){
      el.handler = (e) => {
        e.target.value =e.target.value.toString().replace(/[^\d]/g, "")
     }
     //只能输入正整数，且不能以0开头
     } else if(binding.arg==='int0'){
      el.handler = (e) => {
        e.target.value =e.target.value.toString().replace(/[^\d]/g, "")
        //前两位不能是0加数字
        e.target.value = e.target.value.toString().replace(/^0\d[0-9]*/g,'');
     }
     //只能输入正整数
    }else if(binding.arg==='ptInt'){
      el.handler = (e) => {
        e.target.value =e.target.value.toString().replace(/\D/g, "")
      }
     }else{
      el.handler = (e) => {
         e.target.value =e.target.value.toString().replace(/[^\.\d-]/g, "")
      }
     }
    el.children[0].addEventListener("input", el.handler)
  },
  unbind(el) {
    el.children[0].removeEventListener('input', el.handler);
  },
})
// 这个原生输入框  限制输入内容只限金额
const moneynative =  Vue.directive("moneynative",{
  bind(el, binding) {
    var defaultVal = {
      num:2,   //Number小数点位数
      couldNegative:false, //负数？
    }
    let num = Object.assign(defaultVal,binding.value).num
    let couldNegative = Object.assign(defaultVal,binding.value).couldNegative
    el.handler = (e) => {
      if(!e.target.value)return
      let miusFont = (couldNegative && e.target.value.slice(0,1)== '-')?'-':''
      let valueMiddle = e.target.value
      valueMiddle = valueMiddle.toString().replace(/[^\d\.]/g, '');  //如果输入非数字，则替换为''
      //必须保证第一个为数字而不是.
      valueMiddle = valueMiddle.toString().replace(/^\./g,'');
      //前两位不能是0加数字
      valueMiddle = valueMiddle.toString().replace(/^0\d[0-9]*/g,'');
      //保证只有出现一个.而没有多个.
      valueMiddle = valueMiddle.toString().replace(/\.{2,}/g,'.');
      //保证.只出现一次，而不能出现两次以上
      valueMiddle = valueMiddle.toString().replace('.','$#$').replace(/\./g,'').replace('$#$','.');
      //只能输入两位小数 或者多位
      let str = Array.from({length:num}).reduce((total,item)=>{
        return total+='\\d'
      },'')
      let part = `/^(\\-)*(\\d+)\\.(${str}).*$/`
      valueMiddle = valueMiddle.toString().replace(eval(part),'$1$2.$3');
      e.target.value = miusFont+valueMiddle
      el.dispatchEvent(new Event('input'));
    }
    el.addEventListener("change", el.handler)
    el.addEventListener("blur", el.handler)

  },
  unbind(el) {
    el.removeEventListener('change', el.handler);
    el.removeEventListener("blur", el.handler)
  },
})
// 仅针对element ui input框 限制输入内容只限金额
const money =  Vue.directive("money",{
  //仅针对element ui input框
  bind(el, binding) {
    var defaultVal = {
      num:2,   //小数点位数限制 不能超过2位
      limit:8, //整数部分限制 不能超过8位
      couldNegative:false, //是否能为负数    默认:不能为负 false
    }
    let _assign = Object.assign(defaultVal,binding.value) //合并
    let limitNum = '1'.padEnd(_assign.limit,0) - 0
    let num = _assign.num
    let couldNegative = _assign.couldNegative
    el.handler = (e) => {

      if(!e.target.value)return
      let miusFont = (couldNegative && e.target.value.slice(0,1)== '-')?'-':''
      let valueMiddle = e.target.value
      valueMiddle = valueMiddle.toString().replace(/[^\d\.]/g, '');  //如果输入非数字，则替换为''
      //必须保证第一个为数字而不是.
      valueMiddle = valueMiddle.toString().replace(/^\./g,'');
      //前两位不能是0加数字
      valueMiddle = valueMiddle.toString().replace(/^0\d[0-9]*/g,'');
      //保证只有出现一个.而没有多个.
      valueMiddle = valueMiddle.toString().replace(/\.{2,}/g,'.');
      //保证.只出现一次，而不能出现两次以上
      valueMiddle = valueMiddle.toString().replace('.','$#$').replace(/\./g,'').replace('$#$','.');
      //只能输入两位小数 或者多位
      let str = Array.from({length:num}).reduce((total,item)=>{
        return total+='\\d'
      },'')
      let part = `/^(\\-)*(\\d+)\\.(${str}).*$/`
      valueMiddle = valueMiddle.toString().replace(eval(part),'$1$2.$3');
      if ((valueMiddle - 0) >= limitNum) {
        valueMiddle = limitNum - 1
      }
      e.target.value = miusFont + valueMiddle
      el.children[0].dispatchEvent(new Event('input'));

    }
    el.children[0].addEventListener("change", el.handler)
    el.children[0].addEventListener("blur", el.handler)
  },
  unbind(el) {
    el.children[0].removeEventListener('change', el.handler);
    el.children[0].removeEventListener("blur", el.handler)
  },
})
//  限制输入内容大写英文字母
const ENG =  Vue.directive("ENG",{
  bind(el, binding) {
    el.handler = (e) => {
      if(!e.target.value)return
      let value = e.target.value.replace(/[^a-zA-Z]/g, '')
      e.target.value = value.toUpperCase()
      el.children[0].dispatchEvent(new Event('input'));
    }
    el.addEventListener("change", el.handler)
    el.addEventListener("blur", el.handler)

  },
  unbind(el) {
    el.removeEventListener('change', el.handler);
    el.removeEventListener("blur", el.handler)
  },
})


const clamp =  Vue.directive("clamp",{
  /**
   * binding
   * @param (Number | String | 'auto').
   * @note  Number 行数  String 高度px auto 根据父元素高度自动计算
   */
  bind(el, binding) {
    $clamp(el,{clamp:binding.value||'auto'});
  },
  update(el, binding){
    if(binding.oldValue == binding.value)return
    $clamp(el,{clamp:binding.value});
  },
  unbind(el) {

  },
})
export{focus,zoom,move,input,money}
